import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { BaseDialog } from 'components'
import { SelectPlanActionField, StagedPlanActionsTable } from './components'

import useSnackbar from 'hooks/useSnackbar'
import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import helpers from 'helpers'
import * as service from 'service'
import theme from 'theme'

import useStyles from './styles'

const SendPlanActionsModal = ({ open, setOpen, evidencePlanActions = [] }) => {
  const [stagedPlanActions, setStagedPlanActions] = useState([])
  const [saving, setSaving] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()
  const { companySupplierId } = useThirdPartyManagementStepper()

  const options = evidencePlanActions
    .map((evidencePlanAction) => ({
      id: evidencePlanAction.id,
      name: `#${evidencePlanAction.id} - Plano de Ação`,
    }))
    .filter((option) => !!option.id)

  const handleSave = async () => {
    if (isEmpty(stagedPlanActions)) return

    try {
      setSaving(true)
      await service.dponet.suppliers.evidencePlanActions.send({
        companySupplierId,
        evidencePlanActionIds: stagedPlanActions.map(
          (item) => item.evidencePlanActionId,
        ),
      })
      snackbar.open({
        message: 'Planos de ação enviados com sucesso!',
        variant: 'success',
      })
      setStagedPlanActions([])
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao enviar planos de ação',
        variant: 'error',
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Selecionar Plano de Ação"
      dialogSize="sm"
      fullWidth
      closeButtonText="Fechar"
      actionButtonText="Enviar"
      actionButton={handleSave}
      disableButton={isEmpty(stagedPlanActions)}
      closeIconButton
      loading={saving}
      accentColor={theme.palette.primary.main}
    >
      <Box className={classes.content}>
        <SelectPlanActionField
          options={options}
          stagedPlanActions={stagedPlanActions}
          onStage={(item) =>
            setStagedPlanActions((current) => [...current, item])
          }
          saving={saving}
        />

        <StagedPlanActionsTable
          stagedPlanActions={stagedPlanActions}
          setStagedPlanActions={setStagedPlanActions}
          saving={saving}
        />
      </Box>
    </BaseDialog>
  )
}

SendPlanActionsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  evidencePlanActions: PropTypes.array,
}

export default SendPlanActionsModal
